export const environment = {
  production: false,
  apiUrl: 'https://speech-dev-api.necxt-ia.com.br',
  redirectUrl: 'https://speech-dev.necxt-ia.com.br',
};
